import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { ChatBubbleOutline } from '@mui/icons-material';
import { Alert } from '../../Alert/alert.components';
import { useActiveOutOfOfficeQuery } from '@uplift/queries';
import { CalendarDateService } from '@uplift/services';


export const OutOfOfficeNotice: React.FC<{ providerId: string }> = ({ providerId }) => {
  const { data: outOfOffice, isLoading } = useActiveOutOfOfficeQuery(providerId);

  if (isLoading || !outOfOffice) return null;

  const startDate = CalendarDateService.date(outOfOffice.startDate).format('MMMM D');
  const endDate = CalendarDateService.date(outOfOffice.endDate).format('MMMM D, YYYY');

  return (
    <Alert severity="warning" title="Provider is currently out of office" sx={{ mx: 2, mt: 2 }}>
      <Typography variant="body2">
        Out of office: {startDate} – {endDate}
      </Typography>
      <Typography variant="body2" mt={1}>
        If you need assistance and aren&apos;t getting a response, please contact Support at{' '}
        <Link href="mailto:help@joinuplift.co">
          help@joinuplift.co
        </Link>
        .
      </Typography>
    </Alert>
  );
};
